export default __webpack_public_path__ + "static/media/cp_geo_vu.f228f473.svg";